import { render } from "./ToDoItem.vue?vue&type=template&id=a02c83b6&scoped=true"
import script from "./ToDoItem.vue?vue&type=script&lang=js"
export * from "./ToDoItem.vue?vue&type=script&lang=js"

import "./ToDoItem.vue?vue&type=style&index=0&id=a02c83b6&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a02c83b6"]])

export default __exports__